import { render, staticRenderFns } from "./ShoppingListPosition.vue?vue&type=template&id=672e36bb&scoped=true"
import script from "./ShoppingListPosition.vue?vue&type=script&lang=ts"
export * from "./ShoppingListPosition.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingListPosition.vue?vue&type=style&index=0&id=672e36bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e36bb",
  null
  
)

export default component.exports